var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87 5H19.62L18.68 4H6.68L5.87 5ZM21.29 5.23C21.58 5.57 21.75 6 21.75 6.5V19C21.75 19.5304 21.5393 20.0391 21.1642 20.4142C20.7891 20.7893 20.2804 21 19.75 21H5.75C5.21957 21 4.71086 20.7893 4.33579 20.4142C3.96071 20.0391 3.75 19.5304 3.75 19V6.5C3.75 6 3.92 5.57 4.21 5.23L5.59 3.55C5.87 3.21 6.28 3 6.75 3H18.75C19.22 3 19.63 3.21 19.9 3.55L21.29 5.23ZM6.75 18H12.75V15H6.75V18Z",
    fill: "#5E17EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiPackage);
export default __webpack_public_path__ + "static/media/mdi_package.1286c71566f7251be1bd9c4eee03a0f9.svg";
export { ForwardRef as ReactComponent };